import loginStoreMutations from '@/state/loginStore/loginStoreMutations'
import loginStoreActions from '@/state/loginStore/loginStoreActions'
import getLoginStoreDefaultState from '@/state/loginStore/loginStoreDefaultState'

let state = getLoginStoreDefaultState()

export const loginStore = {
  namespaced: true,
  state,
  getters: {
    auth: state => state.auth
  },
  mutations: loginStoreMutations,
  actions: loginStoreActions
}
